import { useState, useEffect, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import axios from "axios"
import "./DocentePlataforma.css"
import ModalMatricular from "./ModalMatricular"
import comprueboPermisos from "../tools/comprueboPermisos"
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario"
import LogsUsuarioMiIsep from "../modulos/LogsUsuarioMiIsep"
import Swal from "sweetalert2"
import * as XLSX from "xlsx"
import { saveAs } from "file-saver"
import jsPDF from "jspdf"
import autoTable from "jspdf-autotable"

const DocentePlataforma = () => {

  const navigate = useNavigate()

  const [docentes, setDocentes] = useState([])
  const [busqueda, setBusqueda] = useState("")
  const [filtroEstado, setFiltroEstado] = useState("todos")
  const [soloInactivos, setSoloInactivos] = useState(false)
  const [ultimaConsulta, setUltimaConsulta] = useState(null)
  const [ahora, setAhora] = useState(new Date())
  const [sortColumn, setSortColumn] = useState(null)
  const [sortDirection, setSortDirection] = useState("asc")
  const [cargando, setCargando] = useState(false)
  const [filtroResumen, setFiltroResumen] = useState(null)
  const [filtroEscuela, setFiltroEscuela] = useState("todas")
  const [filtroCurso, setFiltroCurso] = useState("todos")
  const [filtroDivision, setFiltroDivision] = useState("todas")
  const Usuario = ObtieneDatosCookies()

  const LIMITE_DIAS = 14
  const escuelasUnicas = [...new Set(docentes.map(d => d.escuela).filter(Boolean))]
  const cursosUnicos = [...new Set(
    docentes
      .filter(d => filtroEscuela === "todas" || d.escuela === filtroEscuela)
      .map(d => d.nombreCurso)
      .filter(Boolean)
  )]
  const divisionesUnicas = [...new Set(
    docentes
      .filter(d =>
        (filtroEscuela === "todas" || d.escuela === filtroEscuela) &&
        (filtroCurso === "todos" || d.nombreCurso === filtroCurso)
      )
      .map(d => d.division)
      .filter(Boolean)
  )]
  useEffect(() => {
    setFiltroCurso("todos")
    setFiltroDivision("todas")
  }, [filtroEscuela])
  useEffect(() => {
    setFiltroDivision("todas")
  }, [filtroCurso])
  useEffect(() => {

    const intervalo = setInterval(() => {

      setAhora(new Date())

    }, 60000) // cada minuto

    return () => clearInterval(intervalo)

  }, [])
  useEffect(() => {
    setUltimaConsulta(new Date())
    cargarDashboard()
  }, [])



  const cargarDashboard = async () => {

    try {

      Swal.fire({
        title: "Actualizando datos",
        text: "Consultando plataforma Moodle...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading()
        }
      })

      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/docentes/obtenerDocentesCursos",
        { usuarioId: Usuario.id }
      )

      const datos = response.data.tabla || []

//       console.log(response)

      setDocentes(datos)

      setUltimaConsulta(new Date())

      Swal.close()

    } catch (err) {

      console.error(err)

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudieron actualizar los datos"
      })

    }

  }



  const diasSinEntrar = (fecha) => {

    if (!fecha) return 999

    const hoy = new Date()
    const f = new Date(fecha)

    const diff = hoy - f

    return Math.floor(diff / (1000 * 60 * 60 * 24))

  }
  const tiempoDesde = (fecha) => {

    if (!fecha) return ""

    const diff = ahora - fecha

    const minutos = Math.floor(diff / 60000)

    if (minutos < 1) return "hace menos de 1 minuto"

    if (minutos === 1) return "hace 1 minuto"

    if (minutos < 60) return `hace ${minutos} minutos`

    const horas = Math.floor(minutos / 60)

    if (horas === 1) return "hace 1 hora"

    return `hace ${horas} horas`

  }
  const formatearFechaHora = (fecha) => {

    if (!fecha) return ""

    return fecha.toLocaleString("es-AR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    })

  }

  const obtenerInfoUltimoAcceso = (fecha) => {

    if (!fecha) {
      return { texto: "Sin registro", clase: "dp-acceso-rojo" }
    }

    const dias = diasSinEntrar(fecha)

    let texto = "Hoy"

    if (dias > 0) {
      texto = `Hace ${dias} día${dias > 1 ? "s" : ""}`
    }

    let clase = "dp-acceso-verde"

    if (dias > 14) clase = "dp-acceso-rojo"
    else if (dias >= 7) clase = "dp-acceso-amarillo"

    return { texto, clase }

  }

//   console.log("Holaaaa")
//   console.log(Usuario)
//   console.log(Usuario.dependenciaNombre)

  const docentesFiltrados = useMemo(() => {

    const texto = busqueda.toLowerCase().trim()

    return docentes.filter(d => {

      const nombre = (d.firstname || "").toLowerCase()
      const apellido = (d.lastname || "").toLowerCase()
      const escuela = (d.escuela || "").toLowerCase()
      const curso = (d.curso || "").toLowerCase()
      const division = (d.division || "").toLowerCase()
      const categoria = (d.categoria || "").toLowerCase()

      const coincideBusqueda =
        nombre.includes(texto) ||
        apellido.includes(texto) ||
        escuela.includes(texto) ||
        curso.includes(texto) ||
        division.includes(texto) ||
        categoria.includes(texto)

      const coincideEstado =
        filtroEstado === "todos" ||
        (filtroEstado === "activos" && !d.matricula_suspendida) ||
        (filtroEstado === "suspendidos" && d.matricula_suspendida)

      const coincideEscuela =
        filtroEscuela === "todas" || d.escuela === filtroEscuela

      const coincideCurso =
        filtroCurso === "todos" || d.nombreCurso === filtroCurso

      const coincideDivision =
        filtroDivision === "todas" || d.division === filtroDivision

      const dias = diasSinEntrar(d.ultimo_acceso)

      let coincideResumen = true

      if (filtroResumen === "activosHoy") coincideResumen = dias === 0
      if (filtroResumen === "sinEntrar7") coincideResumen = dias >= 7
      if (filtroResumen === "sinEntrar14") coincideResumen = dias >= 14
      if (filtroResumen === "suspendidos") coincideResumen = d.matricula_suspendida

      const inactivo = dias > LIMITE_DIAS

      if (soloInactivos) {
        return coincideBusqueda &&
          coincideEstado &&
          coincideResumen &&
          coincideEscuela &&
          coincideCurso &&
          coincideDivision &&
          inactivo
      }

      return coincideBusqueda &&
        coincideEstado &&
        coincideResumen &&
        coincideEscuela &&
        coincideCurso &&
        coincideDivision

    })

  }, [
    docentes,
    busqueda,
    filtroEstado,
    soloInactivos,
    filtroResumen,
    filtroEscuela,
    filtroCurso,
    filtroDivision
  ])





  const escuelasAMostrar = (() => {
    const dependencia = (Usuario.dependenciaNombre || "").toLowerCase();

    const coincidentes = escuelasUnicas.filter(e =>
      e.toLowerCase().includes(dependencia)
    );

    return coincidentes.length > 0 ? coincidentes : escuelasUnicas;
  })();


  const docentesOrdenados = useMemo(() => {

    if (!sortColumn) return docentesFiltrados

    return [...docentesFiltrados].sort((a, b) => {

      let valA = a[sortColumn] || ""
      let valB = b[sortColumn] || ""

      valA = valA.toString().toLowerCase()
      valB = valB.toString().toLowerCase()

      if (valA < valB) return sortDirection === "asc" ? -1 : 1
      if (valA > valB) return sortDirection === "asc" ? 1 : -1

      return 0

    })

  }, [docentesFiltrados, sortColumn, sortDirection])



  const handleSort = (col) => {

    if (sortColumn === col) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc")
    } else {
      setSortColumn(col)
      setSortDirection("asc")
    }

  }



  const exportarExcel = () => {

    const datos = docentesOrdenados.map(d => ({
      Escuela: d.escuela,
      Materia: d.curso,
      Categoria: d.categoria,
      Division: d.division,
      Docente: `${d.firstname} ${d.lastname}`,
      UltimoAcceso: d.ultimo_acceso,
      Estado: d.matricula_suspendida ? "Suspendido" : "Activo"
    }))

    const ws = XLSX.utils.json_to_sheet(datos)
    const wb = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(wb, ws, "Docentes")

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" })

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" })

    saveAs(blob, "docentes_plataforma.xlsx")

  }



  const exportarPDF = () => {

    const doc = new jsPDF()

    const filas = docentesOrdenados.map(d => [
      d.escuela,
      d.curso,
      d.categoria,
      d.division,
      `${d.firstname} ${d.lastname}`,
      d.ultimo_acceso,
      d.matricula_suspendida ? "Suspendido" : "Activo"
    ])

    autoTable(doc, {
      head: [["Escuela", "Materia", "Categoría", "División", "Docente", "Último acceso", "Estado"]],
      body: filas
    })

    doc.save("docentes_plataforma.pdf")

  }



  const totalDocentes = docentesFiltrados.length

  const activosHoy = docentesFiltrados.filter(
    d => diasSinEntrar(d.ultimo_acceso) === 0
  ).length

  const sinEntrar7 = docentesFiltrados.filter(
    d => diasSinEntrar(d.ultimo_acceso) >= 7
  ).length

  const sinEntrar14 = docentesFiltrados.filter(
    d => diasSinEntrar(d.ultimo_acceso) >= 14
  ).length

  const suspendidos = docentesFiltrados.filter(
    d => d.matricula_suspendida
  ).length


  const volver = () => {

    navigate("/Docentes")

  }



  return (

    <div className="dp-container">

      <button className="btn btn-warning" onClick={volver}>
        Volver
      </button>


      {comprueboPermisos(Usuario.funcion, "Matriculo Manual Moodle") &&

        <div style={{ border: "1px solid", padding: "10px", marginTop: "10px" }}>

          <h3>Matriculación manual</h3>

          <ModalMatricular />



        </div>

      }



      <LogsUsuarioMiIsep
        escuela={
          escuelasUnicas.includes(Usuario.dependenciaNombre)
            ? Usuario.dependenciaNombre
            : null
        }
      />

      <h2 className="dp-title">
        Registros de Ingresos Docentes a Plataforma
      </h2>
      {(filtroEscuela !== "todas" || filtroCurso !== "todos" || filtroDivision !== "todas") && (

        <div style={{
          background: "#eef3f7",
          padding: "10px",
          borderRadius: "6px",
          marginBottom: "10px"
        }}>

          <b>Filtros activos:</b>

          {filtroEscuela !== "todas" && (
            <span style={{ marginLeft: "10px" }}>
              🏫 {filtroEscuela}
            </span>
          )}

          {filtroCurso !== "todos" && (
            <span style={{ marginLeft: "10px" }}>
              🎓 {filtroCurso}
            </span>
          )}

          {filtroDivision !== "todas" && (
            <span style={{ marginLeft: "10px" }}>
              📚 División {filtroDivision}
            </span>
          )}

        </div>

      )}

      <button className="dp-button" onClick={cargarDashboard}>
        Actualizar datos
      </button>

      {ultimaConsulta && (

        <div style={{
          marginTop: "10px",
          fontSize: "14px",
          color: "#555"
        }}>

          Última actualización: {formatearFechaHora(ultimaConsulta)}

          <br />

          <span style={{ fontStyle: "italic" }}>
            ({tiempoDesde(ultimaConsulta)})
          </span>

        </div>

      )}
      <div style={{ marginTop: "10px" }}>

        <button className="btn btn-success" onClick={exportarExcel}>
          Exportar Excel
        </button>

        <button className="btn btn-danger" onClick={exportarPDF} style={{ marginLeft: "10px" }}>
          Exportar PDF
        </button>

      </div>


      <hr />

      <div className="dp-resumen">

        <div className="col">
          <div className="card p-2" style={{ cursor: "pointer" }} onClick={() => setFiltroResumen(null)}>
            Total docentes
            <h3>{totalDocentes}</h3>
          </div>
        </div>

        <div className="col">
          <div className="card p-2" style={{ cursor: "pointer" }} onClick={() => setFiltroResumen("activosHoy")}>
            Activos hoy
            <h3>{activosHoy}</h3>
          </div>
        </div>

        <div className="col">
          <div className="card p-2" style={{ cursor: "pointer" }} onClick={() => setFiltroResumen("sinEntrar7")}>
            Sin entrar 7 días
            <h3>{sinEntrar7}</h3>
          </div>
        </div>

        <div className="col">
          <div className="card p-2" style={{ cursor: "pointer" }} onClick={() => setFiltroResumen("sinEntrar14")}>
            Sin entrar 14 días
            <h3>{sinEntrar14}</h3>
          </div>
        </div>

        <div className="col">
          <div className="card p-2" style={{ cursor: "pointer" }} onClick={() => setFiltroResumen("suspendidos")}>
            Suspendidos
            <h3>{suspendidos}</h3>
          </div>
        </div>

      </div>


      {filtroResumen && (

        <div style={{ marginTop: "10px" }}>

          <span className="badge bg-primary">
            Filtro activo: {filtroResumen}
          </span>

          <button
            className="btn btn-sm btn-secondary"
            style={{ marginLeft: "10px" }}
            onClick={() => setFiltroResumen(null)}
          >
            Limpiar filtro
          </button>

        </div>

      )}



      <hr />


      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>

        <input
          className="dp-input"
          placeholder="Buscar docente, curso, escuela..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />

        <select
          className="dp-input"
          value={filtroEscuela}
          onChange={(e) => setFiltroEscuela(e.target.value)}
        >
          <option value="todas">Todas las escuelas</option>

          {escuelasAMostrar.map(e => (
            <option key={e} value={e}>
              {e}
            </option>
          ))}
        </select>

        <select
          className="dp-input"
          value={filtroCurso}
          onChange={(e) => setFiltroCurso(e.target.value)}
        >
          <option value="todos">Todos los cursos</option>
          {cursosUnicos.map(c => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>

        <select
          className="dp-input"
          value={filtroDivision}
          onChange={(e) => setFiltroDivision(e.target.value)}
        >
          <option value="todas">Todas las divisiones</option>
          {divisionesUnicas.map(d => (
            <option key={d} value={d}>{d}</option>
          ))}
        </select>

        <select
          className="dp-input"
          value={filtroEstado}
          onChange={(e) => setFiltroEstado(e.target.value)}
        >
          <option value="todos">Todos</option>
          <option value="activos">Activos</option>
          <option value="suspendidos">Suspendidos</option>
        </select>

        <button
          className="btn btn-secondary"
          onClick={() => setSoloInactivos(!soloInactivos)}
        >
          {soloInactivos ? "Mostrar todos" : "Solo inactivos"}
        </button>

      </div>

      <hr />


      <div className="table-responsive">

        <table className="table table-striped table-bordered">
          <thead className="table-dark">

            <tr>

              <th>#</th>

              <th style={{ cursor: "pointer" }} onClick={() => handleSort("escuela")}>
                Escuela
              </th>

              <th style={{ cursor: "pointer" }} onClick={() => handleSort("nombreCurso")}>
                Curso
              </th>

              <th style={{ cursor: "pointer" }} onClick={() => handleSort("curso")}>
                Materia
              </th>

              <th style={{ cursor: "pointer" }} onClick={() => handleSort("division")}>
                División
              </th>

              <th style={{ cursor: "pointer" }} onClick={() => handleSort("firstname")}>
                Docente
              </th>

              <th style={{ cursor: "pointer" }} onClick={() => handleSort("ultimo_acceso")}>
                Último acceso
              </th>

              <th style={{ cursor: "pointer" }} onClick={() => handleSort("matricula_suspendida")}>
                Estado
              </th>

            </tr>

          </thead>

          <tbody>

            {docentesOrdenados.map((d, i) => {

              const acceso = obtenerInfoUltimoAcceso(d.ultimo_acceso)

              return (

                <tr key={d.userid + "-" + d.courseid}>

                  <td>{i + 1}</td>

                  <td>{d.escuela}</td>

                  <td>
                    <strong>{d.nombreCurso || "-"}</strong>
                  </td>

                  <td>{d.curso}</td>

                  <td>{d.division}</td>

                  <td>{d.firstname} {d.lastname}</td>

                  <td>
                    <span className={`dp-acceso-badge ${acceso.clase}`}>
                      {acceso.texto}
                    </span>
                  </td>

                  <td>
                    {d.matricula_suspendida ? "Suspendido" : "Activo"}
                  </td>

                </tr>

              )

            })}

          </tbody>



        </table>

      </div>

    </div>

  )

}

export default DocentePlataforma